import { useEffect, useRef } from 'react'
import useMapsSDK from '../../hooks/use-maps-sdk'

export default function Map({ style, options, onMapLoad, ...props }) {
  const mapRef = useRef()
  const { areScriptsReady, maps } = useMapsSDK()

  useEffect(() => {
    if (areScriptsReady) {
      const map = new maps.Map(mapRef.current, options)

      onMapLoad(map)
    }
  }, [areScriptsReady, maps, options, onMapLoad])

  return <div style={style} ref={mapRef} {...props} />
}
